import { Button } from '@mui/material';
import React, { useRef, useState } from 'react'
import styled from 'styled-components';
import { auth, db } from '../firebase';
import firebase from 'firebase';
import { useAuthState } from 'react-firebase-hooks/auth';

function ChatInput({channelName,channelId,chatref}) {
    const [user] = useAuthState(auth);
    const [input,setinput] = useState('');
    const sendMessage = e =>{
        e.preventDefault();
        if(!channelId){
            return false;
        }
        db.collection('rooms').doc(channelId).collection('messages').add({
            message: input,
            timestamp :firebase.firestore.FieldValue.serverTimestamp(),
            user : user?.displayName,
            userImage : user?.photoURL,
        });
        chatref?.current?.scrollIntoView({behavior : "smooth",});
        setinput('');
    };

  return (
    <ChatInputContainer>

        <form>
            <input value={input} onChange={e => setinput(e.target.value)} placeholder={`Message #${channelName}`}/>
            <Button hidden type='submit' onClick={sendMessage}>Send</Button>
        </form>
    </ChatInputContainer>
  )
}

export default ChatInput
const ChatInputContainer = styled.div`
border-radius: 20px;
>form{
    position: relative;
    display: flex;
    justify-content: center;
}
>form>input{
    position: fixed;
    bottom: 30px;
    width: 60%;
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 20px;
    outline: none;
}
>form > button{
    display: none !important;
}
`;